import {
	InteractionFilterActions,
	useInteractionFilterStore,
} from "@/common/stores/nonpersistingStores/interactionfilter";
import { useAuth } from "@/hooks/authentication";
import { useEffect } from "react";
import { AppCacheState, CacheKey, useAppCacheStore } from "@/common/stores/persistingStores/app";

export const useInteractionFilterManager = () => {
	const authContext = useAuth();
	const interactionFilterActions = useInteractionFilterStore(
		(actions: InteractionFilterActions) => actions
	);

	const appStoreCache = useAppCacheStore((state: AppCacheState) => state.cache);

	useEffect(() => {
		if (!authContext.isLogged) {
			return;
		}
		const activeData = appStoreCache[CacheKey.ActiveListFilterData];
		const waitingData = appStoreCache[CacheKey.WaitingListFilterData];

		if (activeData) {
			interactionFilterActions.setActive(activeData);
		}
		if (waitingData) {
			interactionFilterActions.setWaiting(waitingData);
		}
	}, [authContext.isLogged]);
};
